import React, { memo, useState, useCallback, useEffect, VFC, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Center, Spinner, Box, VStack, UnorderedList, ListItem, Text } from "@chakra-ui/react";
import { useLoginUser } from "../../hooks/providers/useLoginUserProvider";
import { PrimaryButton } from "../../components/atoms/button/PrimaryButton";
import { ErrorDialog } from "../../components/organisms/modal/ErrorDialog";
import { API, Auth } from 'aws-amplify';
import { LogoutButton } from "../../components/atoms/button/LogoutButton";
import { useUser } from "../../hooks/useUser";
// import { useOpelog } from '../../hooks/useOpelog';

export const Login: VFC = memo(() => {
  const { loginUser, setLoginUser } = useLoginUser();
  const [ token, setToken ] = useState('');
  const [ errObj, setErrObj ] = useState(null);
  const [ issueArn, setIssueArn ] = useState('not_set');
  const [ groupName, setGroupName ] = useState('not_set');
  const [ groupIssueArn, setGroupIssueArn ] = useState('not_set');
  const [ noticeId, setNoticeId ] = useState('not_set');
  const processingRef = useRef(false);
  type GroupStatus = "" | "ready" | "set" | "not_set";
  const [ groupStatus, setGroupStatus ] = useState<GroupStatus>("");
  const appType = process.env.REACT_APP_APP_TYPE;
  const { refreshToken } = useUser();
  // const { OutputOpelog } = useOpelog();
  // const logFlag = useRef(false);
  const loginFlag = useRef(false);
  
  // home画面に遷移する準備
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // ログイン状態確認
  useEffect(() => {
    (async() => {
      
      //console.log(1);
      //envType === 'DEV' && console.log(processingRef.current);
      
      if (processingRef.current === false) {
        processingRef.current = true;
        
        try {
          const session = await Auth.currentCredentials();
          loginUser.envType === 'DEV' && console.log(session);
          
          // session が取得できるとログイン有効 (未ログインの場合、session 取得でエラーになる)
          const user = await Auth.currentAuthenticatedUser();
          setLoginUser({
            username: user.username,
            email: '',
            userKind: '',
            userGroup: 'dev',
            envType: process.env.REACT_APP_ENV_TYPE === undefined ? 'STG' : process.env.REACT_APP_ENV_TYPE,
            eTime: Math.floor(new Date().getTime()/1000),
            token: user.signInUserSession.accessToken.jwtToken,
            param: {},
            issue_cloud_list: [],
            case_search_days: 0,
            group_search_days: 0,
            mypage_search_days: 0,
            mailgroup_search_days: 0,
            sfdc_url: '',
            bu_list: [],
            mailgroup_class_list: [],
            mailgroup_cloud_list: [],
            max_group_search_days: 0,
            max_issue_search_days: 0,
            max_case_search_days: 0,
            max_mail_search_days: 0,
            nec_network: false,
            necFlag: false,
            department: '',
            jobTitle: '',
          });
          setToken(user.signInUserSession.accessToken.jwtToken);
          loginUser.envType === 'DEV' && console.log(user);
          
        } catch (err) {
          loginUser.envType === 'DEV' && console.log(err);
        }
      }
      //console.log(2);
      
    })()
  }, [loginUser,setLoginUser])
  
  // ログイン後処理
  useEffect(() => {
    // console.log(token,groupStatus,loginUser.email,loginFlag);
    // エラー発生時、loginUserがクリアされるが、tokenがある場合は再度ログイン情報を取得
    if (token !== '' && (groupStatus === '' || (groupStatus === 'set' && !loginUser.email && loginFlag.current === false )) ){
      // console.log(loginUser.userKind);
      setGroupStatus("ready");
      
      // 直接指定パラメータの取り出し
      setIssueArn(sessionStorage.getItem('issueArn') ?? '');
      setGroupName(sessionStorage.getItem('groupName') ?? '');
      setGroupIssueArn(sessionStorage.getItem('groupIssueArn') ?? '');
      setNoticeId(sessionStorage.getItem('noticeId') ?? '');
      
      //console.log(12);
      (async() => {
        const apiName = 'BackendApi';
        const path = '/login';
        const params = {
          headers: {
            'X-Api-Version': process.env.REACT_APP_API_VERSION,
            'X-NecAuth-Token': token
            // 'X-NecAuth-Token': await refreshToken()
          },
          'body': {
            username:loginUser.username,
            appType :process.env.REACT_APP_APP_TYPE,
            token: token,
          }
        };
        loginUser.envType === 'DEV' && console.log("login_params",params);
        
        await API.post(apiName, path, params)
        .then(res => {
          loginUser.envType === 'DEV' && console.log("login_res",res);
          if( appType === 'ADMIN' && !res.login_info.userGroup ){
            // お客様でない（=ADMIN）かつグループに所属していない場合は、実行させない
            // お客様側はグループ所属なし
            setGroupStatus("not_set");
          
          }else{
            // ログイン者情報の設定
            setLoginUser({
              username: res.login_info.username,
              email: res.login_info.email,
              userGroup: res.login_info.userGroup,
              userKind: res.login_info.userKind,
              envType: process.env.REACT_APP_ENV_TYPE === undefined ? 'STG' : process.env.REACT_APP_ENV_TYPE,
              eTime: Math.floor(new Date().getTime()/1000),
              token: token,
              param: {},
              issue_cloud_list: res.issue_cloud_list,
              case_search_days: res.case_search_days,
              group_search_days: res.group_search_days,
              mypage_search_days: res.mypage_search_days,
              mailgroup_search_days: res.mailgroup_search_days,
              sfdc_url: res.sfdc_url,
              bu_list: res.bu_list,
              mailgroup_class_list: res.mailgroup_class_list,
              mailgroup_cloud_list: res.mailgroup_cloud_list,
              max_group_search_days: res.max_group_search_days,
              max_issue_search_days: res.max_issue_search_days,
              max_case_search_days: res.max_case_search_days,
              max_mail_search_days: res.max_mail_search_days,
              nec_network: res.nec_network,
              necFlag: res.domain_type === 'NEC' ? true : false ,
              department: res.login_info.department,
              jobTitle: res.login_info.jobTitle,
            });
            
            // bu名の設定
            let buName = 'すべて';
            if( res.login_info.userGroup === 'exec' && res.login_info.department ){
              const split_name = res.login_info.department.split('／');
              if( split_name.length > 1 ){
                buName = split_name[1];
                buName = buName.replace(/＜/g, "");
                buName = buName.replace(/＞/g, "");
                loginUser.envType === 'DEV' && console.log(buName);
              }
            }
            sessionStorage.setItem(
              'buName',
              res.bu_list.find((obj:{bu_name:string;convert_list:string[]}) => obj.bu_name === buName) ? buName : 'すべて'
            );
            
            // 設定完了
            setGroupStatus("set");
          }
        })
        .catch(err => {
          setErrObj(err);
          if (err.response && typeof(err.response.data) === 'string' &&
            err.response.data === "user does not belong to any group") {
            setGroupStatus("not_set");
          }
        })
        .finally(() => {
          //console.log('finally');
          loginFlag.current = true;
        });
      })();
    }
    
  }, [setLoginUser,groupStatus,token,appType,refreshToken,loginFlag]);
  
  // useEffect(() => {
  //   if( groupStatus === 'set' && logFlag.current === false && loginUser.email ){
  //     logFlag.current = true;
  //     OutputOpelog( 'nec_notice', 'login', '');
  //   }
    
  // }, [groupStatus,logFlag,loginUser.email]);
  
  // /tenantList
  // /tenantListFrame
  useEffect(() => {
    if( groupStatus !== 'set' || loginUser.email === '' ) return;
    
    if( issueArn ){
      navigate(`/issueDetail?issueArn=${issueArn}`);
      sessionStorage.removeItem('issueArn');
      
    }else if( groupName ){
      navigate(`/issueGroupDetail?groupName=${groupName}`);
      sessionStorage.removeItem('groupName');
    
    }else if( groupIssueArn ){
      navigate(`/issueGroupDetail?groupIssueArn=${groupIssueArn}`);
      sessionStorage.removeItem('groupIssueArn');
    
    }else if( noticeId ){
      navigate(`/noticeDetail?noticeId=${noticeId}`);
      sessionStorage.removeItem('noticeId');
    }
    
    loginUser.envType === 'DEV' && console.log(loginUser);
    
  }, [groupStatus,navigate,issueArn,groupName,groupIssueArn,noticeId,loginUser.email]);
  
  // リロード用
  useEffect(() => {
    const url = searchParams.get("url");
    if( url ) navigate(url);
  }, [searchParams]);
  
  // ホームボタン押下時
  const onClick = useCallback(()=> {
    navigate("/home");
  }, [navigate]);
  
  return (
    <>
      {errObj && groupStatus === 'ready' ? (
        <ErrorDialog errTitle="ログイン処理" errObj={errObj} opeErrMes='' />
        
      ) : loginUser.username && groupStatus === 'not_set' ? (
        <Center>
        <VStack>
          <Box
          w={{base: "90vw", md: "650px" }}
            bg="white"
            borderRadius="10px"
            shadow="md"
            margin="20px"
            alignItems="center"
            padding="20px"
          >
          <VStack>
            <Box alignItems="left" padding="20px">
              <UnorderedList>
                <ListItem>本システムを利用するための権限がありません。</ListItem>
              </UnorderedList>
            </Box>
            <Box h="40px" alignItems="center" padding="0px">
              <LogoutButton btnName="ログアウト" size="md" />
            </Box>
          </VStack>
          </Box>
        </VStack>
        </Center>
        
      ) : loginUser.email && groupStatus === 'set' ? (
        <Center>
        <VStack>
          <Box
            w={{base: "90vw", md: "850px" }}
            bg="white"
            borderRadius="10px"
            shadow="md"
            margin="20px"
            alignItems="center"
            padding="20px"
          >
          <VStack alignItems="center">
            <Box h="100%" as="u">
              <Text fontSize="xl">マルチクラウド障害通知システムのご利用にあたって</Text>
            </Box>
            <Box w={{base: "90vw", md: "800px" }} h="70vh" padding="20px">
              <iframe title='usage' src="./notice.html" width="100%" height="100%"></iframe>
              
            </Box>
            <Box h="40px" alignItems="center" padding="0px">
              <PrimaryButton type='btn' onClick={onClick}>
                ホームへ
              </PrimaryButton>
            </Box>
          </VStack>
          </Box>
        </VStack>
        </Center>
        
      ) : (
        <Center h="100vh">
          <Box>
            <Text>ログイン処理には時間がかかる場合があります。</Text>
            <Text>しばらくお待ちください。。。</Text>
          </Box>
          <Spinner color="teal.500" />
        </Center>
        
      )}
    </>
  );
});

// const ContactInformation = () => {
  
//   return (
//     <VStack>
//       <Text>本サービスの問い合わせ先：</Text>
//       <Text fontSize="xs" color="gray.500">
//       日本電気株式会社（support@aws.jp.nec.com）
//       </Text>
//     </VStack>
//   );
// };